import { FileDto } from '@tallo/file-manager';
import { RenterDto } from '@tallo/renter';

import { ApplicationBackgroundCheckStatus } from '../enums/application-background-check-status.enum';
import { ApplicationStatus } from '../enums/application-status.enum';
import { BackgroundRecordsProvider } from '../enums/background-records-provider.enum';
import { ReportFormats } from '../enums/report-format.type';
import { ApplicationReferenceDto } from './application-reference.interface';
import { ApplicationEmploymentInfoDto } from './employment.interface';
import { ApplicationRenterDetailsDto } from './renter-details.interface';
import { ApplicationResidenceInfoDto } from './residence-info.interface';

export interface ApplicationDto {
  id: string;
  type: ApplicantType;
  status: ApplicationStatus;
  /** Aggregate of the two legs below: Finished once every ordered leg is. */
  backgroundCheckStatus: ApplicationBackgroundCheckStatus;
  /** Vendor for the criminal + eviction reports. Null = credit only (co-signer). */
  backgroundRecordsProvider: BackgroundRecordsProvider | null;
  /** TransUnion credit report leg. */
  creditCheckStatus: ApplicationBackgroundCheckStatus;
  /** Criminal + eviction leg; null when no records leg was ordered. */
  backgroundRecordsCheckStatus: ApplicationBackgroundCheckStatus | null;
  /** ISO timestamp when the renter accepted the screening consent. Null = not yet. */
  screeningConsentAcceptedAt: string | null;
  /** How each report is delivered — the PDF ones go through the `report/pdf` endpoints. */
  reportFormats: ReportFormats;
  /** ISO timestamp when the landlord approved viewing the criminal report (bifurcated-screening jurisdictions). Null = not yet approved. */
  criminalScreeningApprovedAt: string | null;
  screeningRequestRenterId: string;
  expiresAt: string;
  isPaid: boolean;
  renterDetails: ApplicationRenterDetailsDto | null;
  employmentInfo: ApplicationEmploymentInfoDto[];
  references: ApplicationReferenceDto[];
  residenceInfo: ApplicationResidenceInfoDto[];
  photoIds: FileDto[];
  petPhotos: FileDto[];
  additionalDocuments: FileDto[];
  proofsOfIncome: FileDto[];
  createdAt: string;
  updatedAt: string;
}

export enum ApplicantType {
  APPLICANT = 'Applicant',
  CO_APPLICANT = 'Co-Applicant',
  CO_SIGNER = 'Co-Signer',
}

export interface ApplicationWithRenterDto extends ApplicationDto {
  renter: RenterDto;
}
